import { render, staticRenderFns } from "./TemplateFlowBanner.vue?vue&type=template&id=20462565&"
import script from "./TemplateFlowBanner.vue?vue&type=script&lang=ts&"
export * from "./TemplateFlowBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports